<template>
  <div class="head clearfix">
    <div class="content ypy">
      <div class="logo">
        <router-link to="/">
          <!-- <svg-icon icon-class="logo"></svg-icon> -->
          <div class="boo">
            <img
              style="width: 74px"
              :src="require('../../../basa/images/logos.png')"
            />
            <span class="titles">分包电子采购共享平台</span>
          </div>
        </router-link>
      </div>
      <div class="search fl">
        <el-input
          class="search-input fl"
          v-model="name"
          :placeholder="$t('page.content.searchPlaceholder')"
          clearable
        ></el-input>
        <el-button type="text" class="search-btn fl" @click="search">{{
          $t("page.content.search")
        }}</el-button>
      </div>
      <div class="clearfix"></div>
    </div>

    <div class="content classes piy">
      <!-- <div :class="['all-classes fl', hoverClass]" ref="catalogInfo">
        {{ $t("page.content.all") }}
        <div class="catalog-info-hide">
          <div class="catalog-info">
            <ul class="cate-menu">
              <template v-for="(item, index) in catalogList">
                <li :key="index" class="catalog-li">
                  <div style="position: relative">
                    <img class="pr-5 catalog-img" :src="item.coverUrl" />
                    <div class="pl20 catalog-item ell">
                      <template v-for="(item1, index1) in item.children">
                        <el-link
                          :key="index1"
                          :underline="false"
                          @click="handleClickCategory(item1)"
                          class="mr5"
                          >{{ item1.categoryName }}</el-link
                        >
                      </template>
                    </div>
                  </div>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import store from "@/config/store";
import { getUserInfo1 } from "@/config/api/login";
import { mixinHomePage } from "../../../mixins/mixin-common/mixin-homePage";
export default {
  name: "shopHead",
  mixins: [mixinHomePage],
  data() {
    return {
      activeIndex: "0",
      brandList: [
        {
          name: this.$t("page.content.menu1"), //首页
          type: 1,
          to: "/"
        },
        {
          name: this.$t("page.content.menu4"), //分包商注册
          type: 4
        }
      ],
      name: this.$route.query.name
    };
  },
  methods: {
    init() {
      if (this.loginInfo.name) {
        // 已登录
        this.brandList = [
          {
            name: this.$t("page.content.menu1"), //首页
            type: 1,
            to: "/"
          }
        ];
        getUserInfo1({}).then(res1 => {
          if (
            res1.data.data &&
            res1.data.data.umOrganizations &&
            res1.data.data.umOrganizations[0] &&
            res1.data.data.umOrganizations[0].appList &&
            res1.data.data.umOrganizations[0].appList.length > 0
          ) {
            let obj = "";
            for (
              let i = 0;
              i < res1.data.data.umOrganizations[0].appList.length;
              i++
            ) {
              if (
                res1.data.data.umOrganizations[0].appList[i].appId == "100066"
              ) {
                obj = JSON.stringify(
                  res1.data.data.umOrganizations[0].appList[i]
                );
                break;
              }
            }
            if (obj) {
              localStorage.crmsaInfo = obj;
              sessionStorage.userDetal = obj;
              this.brandList.push({
                name: "信息维护", //信息维护
                toUrl: JSON.parse(obj).url,
                type: 11
              });
            } else {
              localStorage.crmsaInfo = "";
              sessionStorage.userDetal = "";
            }
          }
        });
      } else {
        this.brandList = [
          {
            name: this.$t("page.content.menu1"), //首页
            type: 1,
            to: "/"
          },
          {
            name: this.$t("page.content.menu4"), //分包商注册
            type: 4
          }
        ];
      }
    },
    search() {
      // 判断一下，是在搜索页就不执行跳转
      if (this.$route.path.indexOf("searchList") > -1) {
        // let obj = JSON.parse(localStorage.getItem("supInfo"));
        let obj = JSON.parse(localStorage.getItem("usedSupInfo"));
        let code = "";
        let encSupCode = "";
        if (this.$route_query.supCode) {
          code = this.$route_query.supCode;
          encSupCode = this.$route_query.encSupCode;
        } else {
          if (obj) {
            code =
              obj.supCode ||
              obj.getSupInfoByLoginInfoRspBOList[0].supCode ||
              "";
            encSupCode =
              obj.encSupCode ||
              obj.getSupInfoByLoginInfoRspBOList[0].encSupCode ||
              "";
          }
        }
        this.$router.push({
          path: "/searchList",
          query: {
            name: this.name,
            supCode: code,
            encSupCode: encSupCode
          }
        });
        // window.open(url.href, "_self");
      } else {
        let obj = JSON.parse(localStorage.getItem("usedSupInfo"));
        console.log(obj, "obj...");
        let code = "";
        let name = "";
        let encSupCode = "";
        if (this.$route_query.supCode) {
          code = this.$route_query.supCode;
          encSupCode = this.$route_query.encSupCode;
        } else {
          if (obj) {
            code =
              obj.supCode ||
              obj.getSupInfoByLoginInfoRspBOList[0].supCode ||
              "";
            encSupCode =
              obj.encSupCode ||
              obj.getSupInfoByLoginInfoRspBOList[0].encSupCode ||
              "";
            name =
              obj.supName ||
              obj.getSupInfoByLoginInfoRspBOList[0].supName ||
              "";
          }
        }
        let url = this.$router.resolve({
          path: "/searchList",
          query: {
            name: this.name,
            supCode: code,
            encSupCode: encSupCode,
            supName: name
          }
        });
        window.open(url.href, "_blank");
      }
    },
    handleClick(item) {
      if (item.type === 4) {
        window.open(
          this.$addUrlPerFix("sra.iccec.cn/transferPage")
        );
      } else if (item.type == 11) {
        // 信息维护
        window.open(
          item.toUrl,
          // this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
          //   "?CLIENT_ID=" +
          //   "3EB1D859ACB784EA16323A2B4F38CAEC62DB081CB42DFD2F1C20183E4701600A" +
          //   "&CALLBACK_URL=" +
          //   encodeURIComponent(
          //     `${this.$addUrlPerFix(
          //       process.env.VUE_APP_CRMSA_URL
          //     )}?a=3EB1D859ACB784EA16323A2B4F38CAEC62DB081CB42DFD2F1C20183E4701600A`
          //   ),
          "_blank"
        );
      }
    }
  },
  computed: {
    loginInfo() {
      return store.state.user.loginInfo;
    },
    catalogList() {
      return store.state.user.catalogList;
    },
    hoverClass() {
      if (!store.state.user.isPortal) {
        return "catalog-info-hover";
      } else {
        return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-input /deep/ input.el-input__inner {
  border: none !important;
}

.svg-icon {
  width: 100% !important;
  height: 68px !important;
}

.piy {
  margin-top: 10px !important;
}

.boo {
  display: flex;
  align-items: center;
  padding-left: 10px;
  // justify-content: center;
}

.ypy {
  display: flex;
  align-items: center;
}

.titles {
  color: #3a71a8;
  margin-left: 10px;
  font-weight: 500;
  font-size: 22px;
}
</style>
